import { render, staticRenderFns } from "./form.vue?vue&type=template&id=230f5a58&"
import script from "./form.vue?vue&type=script&lang=ts&"
export * from "./form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/peter/dev/subscription-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('230f5a58')) {
      api.createRecord('230f5a58', component.options)
    } else {
      api.reload('230f5a58', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=230f5a58&", function () {
      api.rerender('230f5a58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form.vue"
export default component.exports